import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setSweepRuleUIUpdate')(function setSweepRuleUIUpdate(sweepRuleId, sweepOperation) {
    var sweepRule = store.sweepRules.get(sweepRuleId);
    switch (sweepOperation) {
        case 2 /* Enable */:
            sweepRule.IsEnabled = true;
            break;
        case 3 /* Disable */:
            sweepRule.IsEnabled = false;
            break;
        case 1 /* Delete */:
            store.sweepRules.delete(sweepRuleId);
            store.sweepRuleIds.splice(store.sweepRuleIds.indexOf(sweepRuleId), 1);
            break;
        default:
            throw new Error('Could not find SetSweepRuleOperation');
    }
});
//# sourceMappingURL=setSweepRuleUIUpdate.js.map